import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 55,
	height: 52,
	viewBox: "0 0 55 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M49.587 20.7456C49.2931 19.8366 48.4869 19.1909 47.533 19.105L34.5758 17.9284L29.4521 5.93608C29.0743 5.05719 28.2139 4.48828 27.258 4.48828C26.302 4.48828 25.4417 5.05719 25.0639 5.93813L19.9402 17.9284L6.98097 19.105C6.02879 19.193 5.22457 19.8366 4.92898 20.7456C4.6334 21.6546 4.90638 22.6517 5.62668 23.2802L15.4208 31.8697L12.5327 44.5916C12.3214 45.527 12.6845 46.4939 13.4606 47.0549C13.8778 47.3563 14.3659 47.5098 14.858 47.5098C15.2824 47.5098 15.7034 47.3954 16.0812 47.1693L27.258 40.4893L38.4307 47.1693C39.2483 47.6612 40.2789 47.6163 41.0533 47.0549C41.8298 46.4922 42.1925 45.5249 41.9812 44.5916L39.0931 31.8697L48.8872 23.2819C49.6076 22.6517 49.8826 21.6563 49.587 20.7456Z" })
});
export { SvgStarFilled as ReactComponent };
